export default __webpack_public_path__ + "static/media/terminal4.31fb2eaa.svg";